import styled from 'styled-components'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useIntl } from 'react-intl'
import { CheckCircleIcon } from 'assets/icons/check-circle'

interface Props {
  close: () => void
}

export default function CourseGpsSaveSuccessDialog({ close }: Props): JSX.Element {
  const intl = useIntl()

  return (
    <StyledDialog open onClose={close} hideBackdrop>
      <CloseButton aria-label="Close" onClick={close}>
        <CloseIcon fontSize="small" />
      </CloseButton>
      <StyledDialogContent>
        <SuccessBadge>
          <CheckCircleIcon width={30} height={30} />
        </SuccessBadge>
        <Title>{intl.formatMessage({ id: 'strings.gpsDataSavedDialogTitle' })}</Title>
        <ContentText>{intl.formatMessage({ id: 'strings.gpsDataSavedDialogText' })}</ContentText>
        <CloseHint>{intl.formatMessage({ id: 'strings.gpsDataSavedDialogClose' })}</CloseHint>
      </StyledDialogContent>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    position: relative;
    width: min(328px, calc(100vw - 32px));
    border-radius: 16px;
    border-top: 0.5px solid rgba(255, 255, 255, 0.15);
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.15);
    background: rgba(20, 24, 26, 0.7);
    backdrop-filter: blur(5px);
    color: #fff;
  }
`

const StyledDialogContent = styled(DialogContent)`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`

const SuccessBadge = styled.div`
  margin: auto auto 8px;
  color: #fff;
  background: #0bb163;
  border-radius: 16px;
  display: flex;
  width: 64px;
  height: 64px;
  justify-content: center;
  align-items: center;
`

const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`

const ContentText = styled(DialogContentText)`
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
`

const CloseHint = styled(ContentText)`
  font-weight: 600;
  color: #fff;
`

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  color: rgba(255, 255, 255, 0.7);
  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
`
